import { memo, Ref, useMemo } from "react";

import TableBodyRow from "ds/components/Table/Row";
import { TableColumnMeta } from "ds/components/Table/types";
import { isStickyLeft, isStickyRight } from "ds/components/TableSimple/helpers";
import {
  StackPullRequestItem,
  StackPullRequestRunItem,
} from "shared/Stack/useStackPullRequests/gql";
import { VcsProvider } from "types/generated";

import { STACK_PULL_REQUESTS_RUN_CELLS } from "../Cells/Run";
import { StackPullRequestsTableChildRow } from "../Cells/types";

type StackPullRequestsTableRowRunProps = {
  pullRequest: StackPullRequestItem;
  run: StackPullRequestRunItem;
  stackId: string;
  stackProvider: VcsProvider;
  isAnsible: boolean;
  columns: TableColumnMeta[];
  isFirstColumnPinned: boolean;
  keyboardProps: Record<string, unknown>;
  measureRef: Ref<HTMLDivElement>;
  dataIndex: number;
};

const StackPullRequestsTableRowRun = ({
  pullRequest,
  run,
  stackId,
  stackProvider,
  isAnsible,
  columns,
  isFirstColumnPinned,
  keyboardProps,
  measureRef,
  dataIndex,
}: StackPullRequestsTableRowRunProps) => {
  const item = useMemo<StackPullRequestsTableChildRow>(
    () => ({ kind: "child", pullRequest, run }),
    [pullRequest, run]
  );

  return (
    <TableBodyRow
      {...keyboardProps}
      ref={measureRef}
      dataIndex={dataIndex}
      virtualized
      isGroupChild
      aria-level={2}
    >
      {columns.map((column, i) => {
        const Cell = STACK_PULL_REQUESTS_RUN_CELLS[column.id];
        const cellId = `${pullRequest.id}-${run.id}-${column.id}`;

        return (
          <Cell
            key={cellId}
            id={cellId}
            item={item}
            stackId={stackId}
            stackProvider={stackProvider}
            isAnsible={isAnsible}
            isFirst={i === 0}
            stickyLeft={isStickyLeft(i, isFirstColumnPinned)}
            stickyRight={isStickyRight(i, columns.length)}
          />
        );
      })}
    </TableBodyRow>
  );
};

export default memo(StackPullRequestsTableRowRun);
